<template>
    <div class="cooperate-bank">
        <div class="content-header">
            <h3>
<!--                <el-button v-if="classId!=3" size="mini" type="danger" round plain style="margin-left: 10px" @click="showPrize">查看奖金</el-button>-->
            </h3>
            <el-row :gutter="20" class="list-wrap">
                <el-col :span="6" v-for="(item,index1) in bankList" :key="index1" style="margin-bottom: 10px;">
                    <el-card class="box-card" style="height: 372px;">
                        <div slot="header" class="header-title">
                            <span>{{item.questionClassName}}-{{item.periodName}}</span>
                        </div>
                        <div v-for="(user,index) in item.list" class="text-item">
                            <el-row :style="{color:index<3?'green':''}">
                                <el-col :span="12">{{user.userName}}</el-col>
                                <el-col :span="12">获{{user.voteNum}}票</el-col>
                            </el-row>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <el-dialog
                title="奖金明细"
                :visible.sync="showDialog"
                width="70%"
                center>
            <el-form :inline="true" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
                <el-form-item>
                    <el-date-picker
                            v-model="monthDate"
                            type="month"
                            placeholder="选择年月" value-format="yyyy-MM">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getCooperativePrizeDetail">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="myPriceList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="报告来源" prop="className" ></el-table-column>
                <el-table-column label="报告周次" prop="periodName" ></el-table-column>
                <el-table-column label="报告状态" >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.reportStatus==3" type="success">奖金已结算</el-tag>
                        <el-tag v-else-if="scope.row.reportStatus==2" type="warning">无奖金</el-tag>
                        <el-tag v-else type="danger">奖金未结算</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="姓名" prop="userName" ></el-table-column>
                <el-table-column label="奖金金额" prop="bonus" ></el-table-column>
                <el-table-column label="结算时间" prop="bonusTime"></el-table-column>
                <el-table-column label="报告被赞数" prop="voteNum" ></el-table-column>
                <el-table-column label="点赞人数" prop="totalVoteNum" ></el-table-column>
                <el-table-column label="得赞率" prop="voteRate" ></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="showDialog=false">确 定</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>

    //定义组件
    export default {
        data() {
            return {
                classId:1,
                bankList:[],
                showDialog:false,
                myPriceList:[],
                monthDate:new Date().getFullYear()+'-'+(new Date().getMonth()+1),
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.classId = this.sectionClassId
            this.getCooperativeBankList()
        },
        methods: {
            getCooperativeBankList() {
                this.$store.dispatch('initCooperativeBankList',{questionClassId:this.classId}).then(res=>{
                    this.bankList = res
                })
            },
            getCooperativePrizeDetail() {
                let temDate = this.setYearMonth(this.monthDate)
                this.$store.dispatch('getCooperativePrizeDetail',{questionClassId:this.classId,year:temDate.year,month:temDate.month}).then(res=>{
                    this.myPriceList = res
                })
            },
            showPrize(){
                this.showDialog = true
                this.getCooperativePrizeDetail()
            },
            setYearMonth(date){
                return {year:date.split('-')[0],month:date.split('-')[1]}
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-card__body{
        overflow-y: scroll;
        /*height: 372px;*/
    }
    .cooperate-bank{
        .list-wrap{
            margin: 10px;
            text-align: center;
        }
        .box-card{
            height: 407px;
            .text-item{
               margin-bottom: 10px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/cooperative/cooperativeBank.vue